import { createSelector } from '@ngrx/store';

import { modalsState } from '../root';

export const getModalById = (modalId: number) => createSelector(modalsState, (modals) => modals.find((modal) => modal.id === modalId) || null);
